import React from 'react';

import { SVGComponentProps } from './svg.types';

const InsertRight = ({ fill = 'currentColor', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2H0.5H5.5H6V2.5V11.5V12H5.5H0.5H0V11.5V2.5V2ZM1 3V5H5V3H1ZM1 8V6H5V8H1ZM1 9V11H5V9H1Z"
        fill={fill}
      />
      <g clipPath="url(#clip0_2528:16493)">
        <path
          d="M11.5719 3.5715H10.4576C10.4428 3.5705 10.4288 3.56416 10.4183 3.55365C10.4078 3.54314 10.4015 3.52918 10.4005 3.51436V2.42864C10.4047 2.37371 10.3974 2.31849 10.3792 2.2665C10.3609 2.21451 10.3321 2.16687 10.2945 2.12659C10.2569 2.08631 10.2114 2.05427 10.1608 2.03249C10.1102 2.01071 10.0556 1.99968 10.0005 2.00007C9.94392 1.99903 9.88772 2.0094 9.83525 2.03056C9.78278 2.05173 9.73512 2.08326 9.69511 2.12327C9.6551 2.16327 9.62357 2.21094 9.60241 2.26341C9.58124 2.31588 9.57087 2.37207 9.57191 2.42864V3.54293C9.57091 3.55775 9.56457 3.57171 9.55406 3.58222C9.54356 3.59273 9.5296 3.59907 9.51477 3.60007H8.42906C8.37362 3.59343 8.31741 3.59897 8.26434 3.61631C8.21127 3.63365 8.16262 3.66237 8.12181 3.70047C8.08099 3.73856 8.04899 3.78511 8.02803 3.83686C8.00708 3.88861 7.99768 3.94431 8.00049 4.00007C8.00324 4.11287 8.04928 4.22029 8.12906 4.30007C8.20884 4.37985 8.31626 4.42589 8.42906 4.42864H9.54334C9.55817 4.42965 9.57213 4.43599 9.58263 4.4465C9.59314 4.457 9.59948 4.47096 9.60049 4.48579V5.60007C9.59911 5.65298 9.60852 5.7056 9.62813 5.75476C9.64775 5.80391 9.67716 5.84855 9.71458 5.88597C9.752 5.9234 9.79665 5.95281 9.8458 5.97242C9.89495 5.99204 9.94758 6.00145 10.0005 6.00007C10.1133 5.99732 10.2207 5.95128 10.3005 5.8715C10.3803 5.79171 10.4263 5.6843 10.4291 5.5715V4.45721C10.4301 4.44239 10.4364 4.42843 10.4469 4.41792C10.4574 4.40742 10.4714 4.40107 10.4862 4.40007H11.6005C11.7059 4.39788 11.8064 4.35504 11.8809 4.28049C11.9555 4.20595 11.9983 4.10547 12.0005 4.00007C12.0051 3.94261 11.9973 3.88482 11.9774 3.83071C11.9575 3.77659 11.9261 3.72745 11.8853 3.68669C11.8445 3.64592 11.7954 3.6145 11.7413 3.59461C11.6872 3.57473 11.6294 3.56684 11.5719 3.5715Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2528:16493">
          <rect width="4" height="4" fill="white" transform="translate(8 2)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InsertRight;
